package navigation.settings.tags

import navigation.settings.tags.addedittag.AddEditTagScreenModel
import navigation.settings.tags.alltags.AllTagsScreenModel
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val tagUiModule
    get() =
        module {
            factoryOf(::AllTagsScreenModel)
            factoryOf(::AddEditTagScreenModel)
        }